export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/tree-filter.worker.e41bb0b2.worker.js");
}
